import { OrganizationSubscription } from './models/organization-subscription.model';
import { createFeature, createReducer, on } from '@ngrx/store';
import { OrganizationSubscriptionEffectActions } from './organization-subscription.actions';
import { EntityServiceError } from '../shared/errors/entity-service.error';
import { AccountTeamPageActions } from '../account-team/account-team.actions';

interface State {
  subscription: OrganizationSubscription;
  error: EntityServiceError;
}

const initialState: State = {
  subscription: null,
  error: null,
};

export const organizationSubscriptionFeature = createFeature({
  name: 'organizationSubscription',
  reducer: createReducer(
    initialState,
    on(
      OrganizationSubscriptionEffectActions.loadSubscription,
      AccountTeamPageActions.pageOpened,
      (state) => ({
        ...state,
        subscription: null,
        error: null,
      }),
    ),
    on(
      OrganizationSubscriptionEffectActions.loadSubscriptionSucceeded,
      (state, { subscription }) => ({
        ...state,
        subscription,
      }),
    ),
    on(OrganizationSubscriptionEffectActions.loadSubscriptionErrored, (state, { error }) => ({
      ...state,
      error,
    })),
  ),
});
